import { render, staticRenderFns } from "./MaterialesModal.vue?vue&type=template&id=71c3ef5a&"
import script from "./MaterialesModal.vue?vue&type=script&lang=js&"
export * from "./MaterialesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports